<template>
  <v-container :class="MobileSize ? 'mt-3' : 'mx-0'">
  <!-- <v-container grid-list-xs> -->
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title v-if="!MobileSize" style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;">รายการสั่งซื้อ</v-card-title>
      <v-card-title  v-else class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;"><v-icon color="#27AB9C" class="mr-2" @click="backToMenu()">mdi-chevron-left</v-icon> รายการสั่งซื้อ</v-card-title>
      <!-- <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay> -->
      <v-row no-gutters>
        <v-col cols="12" class="px-2 py-0">
          <a-tabs @change="SelectDetailOrder">
            <a-tab-pane key="ทั้งหมด"><span slot="tab">ทั้งหมด <a-tag color="#27AB9C" style="border-radius: 8px;">{{ countOrderAll }}</a-tag></span></a-tab-pane>
            <a-tab-pane key="ยังไม่ชำระเงิน"><span slot="tab">ยังไม่ชำระเงิน <a-tag color="#E9A016" style="border-radius: 8px;">{{ countOrderNotpaid }}</a-tag></span></a-tab-pane>
            <a-tab-pane key="ชำระเงินสำเร็จ"><span slot="tab">ชำระเงินสำเร็จ <a-tag color="#1AB759" style="border-radius: 8px;">{{ countOrderSuccess }}</a-tag></span></a-tab-pane>
            <a-tab-pane key="ชำระเงินไม่สำเร็จ"><span slot="tab">ชำระเงินไม่สำเร็จ <a-tag color="#D1392B" style="border-radius: 8px;">{{ countOrderFail }}</a-tag></span></a-tab-pane>
            <a-tab-pane key="ชำระเงินแบบเครดิตเทอม"><span slot="tab">ชำระเงินแบบเครดิตเทอม <a-tag color="#1B5DD6" style="border-radius: 8px;">{{ countOrderCreditTerm }}</a-tag></span></a-tab-pane>
            <a-tab-pane key="ยกเลิก"><span slot="tab">ยกเลิก <a-tag color="#f50" style="border-radius: 8px;">{{ countOrderCancel }}</a-tag></span></a-tab-pane>
          </a-tabs>
        </v-col>
        <v-col v-if="disableTable === true" cols="12" md="6" sm="12" class="" :class="!MobileSize ? 'pl-2 pt-0' : 'pl-2 pr-2 mb-3'">
          <v-text-field v-model="search" dense hide-details outlined rounded placeholder="ค้นหาจากรหัสการสั่งซื้อ">
            <v-icon slot="append">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
        <v-col v-if="disableTable === true" cols="12" md="12" sm="12" class="" :class="!MobileSize ? 'pl-3 pr-3 mb-0 mt-4' : 'pl-2 pr-2 mb-3 mt-3'">
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="StateStatus === 'ทั้งหมด'">รายการสั่งซื้อทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 'ยังไม่ชำระเงิน'">รายการสั่งซื้อที่ยังไม่ชำระเงินทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 'ชำระเงินสำเร็จ'">รายการสั่งซื้อที่ชำระเงินสำเร็จทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 'ชำระเงินไม่สำเร็จ'">รายการสั่งซื้อที่ชำระเงินไม่สำเร็จทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 'ชำระเงินแบบเครดิตเทอม'">รายการสั่งซื้อที่ชำระเงินแบบเครดิตเทอมทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 'ยกเลิก'">รายการสั่งซื้อที่ยกเลิกทั้งหมด {{ showCountOrder }} รายการ</span>
        </v-col>
        <v-col cols="12">
          <v-card v-if="disableTable === true" outlined class="small-card mx-2 my-5" min-height="436">
            <v-data-table
              :headers="keyCheckHead == 0 || keyCheckHead === 4 ? headersAll : keyCheckHead == 1 || keyCheckHead == 3 ? headersNoPaid : keyCheckHead == 2 ? headersSuccess : keyCheckHead == 5 ? headersCancel : headers"
              :items="DataTable"
              :search="search"
              :page.sync="page"
              style="width:100%;"
              height="100%"
              @pagination="countOrdar"
              :items-per-page="10"
              class=""
              no-results-text="ไม่พบรหัสการสั่งซื้อที่ค้นหา"
              :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{new Date(item.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })}}
              </template>
              <template v-slot:[`item.paid_datetime`]="{ item }">
                {{ item.paid_datetime === '-' ? item.paid_datetime : new Date(item.paid_datetime).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })}}
              </template>
              <template v-slot:[`item.payment_transaction_number`]="{ item }">
                <div v-if="item.pdf_for_buyer !== ''">
                  <a @click="orderDetail(item)">{{item.payment_transaction_number}}</a>
                </div>
                <div v-else>
                  {{item.payment_transaction_number}}
                </div>
              </template>
              <template v-slot:[`item.payment_transaction_number_icon`]="{ item }">
                <div v-if="item.pdf_for_buyer !== ''">
                  <a @click="orderDetail(item)">
                    <v-btn x-small
                      style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                      :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                      class="pt-4 pb-4">
                      <v-icon color="#27AB9C">mdi-file-document</v-icon>
                    </v-btn>
                  </a>
                </div>
                <div v-else>
                  <span>{{ '-' }}</span>
                </div>
              </template>
              <template v-slot:[`item.transaction_code_icon`]="{ item }">
                <div v-if="item.transaction_code !== '-' && item.required_invoice === '-'">
                  <a @click="GetETaxPDF(item)">
                    <v-btn x-small @click="GetETaxPDF(item)"
                      style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                      :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                      class="pt-4 pb-4">
                      <v-icon color="#27AB9C">mdi-file-document</v-icon>
                    </v-btn>
                  </a>
                </div>
                <div v-else-if="item.transaction_code === '-' && item.required_invoice !== '-'">
                  <span>{{ item.required_invoice }}</span>
                </div>
                <div v-else>
                  <span>{{ '-' }}</span>
                </div>
              </template>
              <template v-slot:[`item.total_amount`]="{ item }">
                {{ Number(item.total_amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
              <template v-slot:[`item.payment`]="{ item }">
                <v-row justify="center" >
                  <v-btn v-if="item.seller_sent_status ==='Success'" text disabled rounded color="#1AB759" small @click="GoToPayment(item)">
                    <b>จ่ายเงิน</b>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn v-else-if="item.seller_sent_status ==='cancel'" text disabled rounded color="#1AB759" small @click="GoToPayment(item)">
                    <b>จ่ายเงิน</b>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn v-else text rounded color="#1AB759" small @click="GoToPayment(item)">
                    <b>จ่ายเงิน</b>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </template>
              <template v-slot:[`item.transaction_status`]="{ item }">
                <span v-if="item.transaction_status === 'Success' && item.seller_sent_status !== 'cancel'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#F0F9EE" text-color="#1AB759">ชำระเงินสำเร็จ</v-chip>
                </span>
                <span v-else-if="item.seller_sent_status === 'cancel' || item.transaction_status === 'Cancel'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#f7c5ad" text-color="#f50">ยกเลิกสินค้า</v-chip>
                </span>
                <span v-else-if="item.transaction_status === 'Pending'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#FCF0DA" text-color="#E9A016">รออนุมัติ</v-chip>
                </span>
                <span v-else-if="item.transaction_status === 'Approve'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#F0F9EE" text-color="#1AB759">อนุมัติ</v-chip>
                </span>
                <span v-else-if="item.transaction_status === 'Credit'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#E5EFFF" text-color="#1B5DD6">ชำระเงินแบบเครดิตเทอม</v-chip>
                </span>
                <span v-else-if="item.transaction_status === 'Fail'">
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#F7D9D9" text-color="#D1392B">ชำระเงินไม่สำเร็จ</v-chip>
                </span>
                <span v-else>
                  <v-chip :class="!MobileSize? 'ma-2' : 'ma-0'" color="#FCF0DA" text-color="#E9A016">ยังไม่ชำระเงิน</v-chip>
                </span>
              </template>
              <template v-slot:[`item.buyer_received_status`]="{ item }">
                <v-row class="pt-5">
                  <v-select v-model="item.buyer_received_status" :items="receive_items" item-text="text" item-value="value" @change="UpdateStatusBuyer(item)" outlined dense></v-select>
                </v-row>
              </template>
              <template v-slot:[`item.detail`]="{ item }">
                <v-btn text rounded color="#27AB9C" small @click="goDetailPO(item)">
                  <b>รายละเอียด</b>
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="disableTable === false" align="center">
          <div class="my-5">
            <v-img src="@/assets/emptypo.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
          </div>
          <h2 v-if="StateStatus === 'ทั้งหมด'" style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสั่งซื้อสินค้า</b></h2>
          <h2 v-else style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสั่งซื้อสินค้าที่{{ StateStatus }}</b></h2>
        </v-col>
      </v-row>
    </v-card>
  <!-- </v-container> -->
  </v-container>
</template>

<script>
import { Encode, Decode } from '@/services'
export default {
  data () {
    return {
      orderList: [],
      StateStatus: 'ทั้งหมด',
      showCountOrder: 0,
      disableTable: false,
      dataRole: '',
      page: 1,
      OrderNamePurchaser: [
        // { key: 0, name: 'ข้อมูลไม่ครบ' },
        { key: 0, name: 'ทั้งหมด' },
        { key: 2, name: 'ยังไม่ชำระเงิน' },
        { key: 1, name: 'รออนุมัติ' },
        { key: 6, name: 'อนุมัติ' },
        { key: 3, name: 'ชำระเงินสำเร็จ' },
        { key: 5, name: 'ชำระเงินไม่สำเร็จ' },
        { key: 4, name: 'ยกเลิก' }

      ],
      OrderNameExtBuyer: [
        { key: 0, name: 'ทั้งหมด' },
        { key: 2, name: 'ยังไม่ชำระเงิน' },
        { key: 3, name: 'ชำระเงินสำเร็จ' },
        { key: 5, name: 'ชำระเงินไม่สำเร็จ' },
        { key: 4, name: 'ยกเลิก' }
      ],
      keyCheckHead: 0,
      headers: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'วันที่สั่งซื้อ', value: 'paid_datetime', filterable: false, sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'จ่ายเงิน', value: 'payment', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' }
      ],
      headersSuccess: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'วัน/เวลาทำธุรกรรม', value: 'paid_datetime', filterable: false, sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' }
        // { text: 'สถานะการรับของ', value: 'buyer_received_status', align: 'center' },
        // { text: 'วันที่ได้รับของ', value: 'received_date', align: 'center' }
      ],
      headersPending: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: ' ', value: 'detail', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' }
        // { text: 'สถานะการรับของ', value: 'buyer_received_status', align: 'center' },
        // { text: 'วันที่ได้รับของ', value: 'received_date', align: 'center' }
      ],
      headersApprove: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: ' ', value: 'detail', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' }
      ],
      headersNoPaid: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, align: 'center', width: '125px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'จ่ายเงิน', value: 'payment', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' }
      ],
      headersCancel: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'วัน/เวลาทำธุรกรรม', value: 'paid_datetime', filterable: false, sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' }
      ],
      headersAll: [
        { text: 'วันที่', value: 'created_at', align: 'center', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'รหัสการสั่งซื้อ', value: 'payment_transaction_number', sortable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ราคา', value: 'total_amount', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบเสนอราคา', value: 'payment_transaction_number_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'ใบกำกับภาษี', value: 'transaction_code_icon', filterable: false, sortable: false, width: '125px', align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'วัน/เวลาทำธุรกรรม', value: 'paid_datetime', filterable: false, sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'สถานะการจ่ายเงิน', value: 'transaction_status', filterable: false, sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: ' ', value: 'detail', align: 'center', filterable: false, sortable: false, class: 'backgroundTable fontTable--text' }
      ],
      receive_items: [
        { text: 'ยังไม่รับ', value: 'not_received' },
        { text: 'รับของแล้ว', value: 'received' }
      ],
      statusSend: { text: 'ยังไม่รับ', value: 'not_received' },
      DataTable: [],
      customClick: (record) => ({
        on: {
          click: () => {
            this.pendingData(record)
          }
        }
      }),
      overlay: false,
      ProcurementData: '',
      responseData: '',
      checkbox: true,
      search: '',
      countOrderAll: 0,
      countOrderPending: 0,
      countOrderNotpaid: 0,
      countOrderSuccess: 0,
      countOrderFail: 0,
      countOrderCancel: 0,
      countOrderApprove: 0,
      countOrderCreditTerm: 0,
      companyData: []
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    DataListOrder () {
      return this.responseData
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/orderCompanyMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/orderCompany' }).catch(() => {})
      }
    },
    DataTable (val) {
      // console.log('DataTable', val)
    },
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 500)
    },
    StateStatus (val) {
      // console.log('val', val)
      if (val === 'ทั้งหมด') {
        this.DataTable = this.orderList.all
        this.keyCheckHead = 0
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 'ยังไม่ชำระเงิน') {
        this.DataTable = this.orderList.not_paid
        this.keyCheckHead = 1
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 'ชำระเงินสำเร็จ') {
        this.DataTable = this.orderList.success
        this.keyCheckHead = 2
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 'ชำระเงินไม่สำเร็จ') {
        this.DataTable = this.orderList.fail
        this.keyCheckHead = 3
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 'ชำระเงินแบบเครดิตเทอม') {
        this.DataTable = this.orderList.credit_term
        this.keyCheckHead = 4
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 'ยกเลิก') {
        this.DataTable = this.orderList.cancel
        this.keyCheckHead = 5
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      }
    }
  },
  async created () {
    // console.log('StateStatus', this.StateStatus)
    this.$EventBus.$emit('changeNavCompany')
    this.$EventBus.$emit('checkPathCompany')
    this.$EventBus.$on('getPOBuyer', this.SwitchRole)
    this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
    if (localStorage.getItem('oneData') !== null && localStorage.getItem('CompanyData') !== null) {
      this.companyData = JSON.parse(Decode.decode(localStorage.getItem('CompanyData')))
      this.ListDataTable()
    } else {
      this.$router.push({ path: '/' }).catch(() => { })
    }
  },
  methods: {
    async GetETaxPDF (val) {
      var data = {
        transactionCode: val.transaction_code
      }
      await this.$store.dispatch('ActionsGetETaxPDF', data)
      var response = await this.$store.state.ModuleCart.stateGetETaxPDF
      // console.log(response)
      if (response.result === 'OK') {
        if (response.etaxResponse.status === 'OK') {
          window.open(`${response.etaxResponse.pdfURL}`)
        }
      }
    },
    backToMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/companyMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/detailCompany' }).catch(() => {})
      }
    },
    async ListDataTable () {
      this.$store.commit('openLoader')
      this.countOrderAll = 0
      this.countOrderNotpaid = 0
      this.countOrderSuccess = 0
      this.countOrderFail = 0
      this.countOrderCancel = 0
      this.countOrderCreditTerm = 0
      var data = {
        role_user: 'purchaser',
        company_id: this.companyData.id
      }
      await this.$store.dispatch('actionsListOrderPurchaser', data)
      var res = await this.$store.state.ModuleAdminManage.stateListOrderPurchaser
      if (res.message === 'Show list order purchaser success') {
        this.$store.commit('closeLoader')
        this.orderList = res.data
        this.countOrderAll = this.orderList.all.length
        this.countOrderNotpaid = this.orderList.not_paid.length
        this.countOrderSuccess = this.orderList.success.length
        this.countOrderFail = this.orderList.fail.length
        this.countOrderCancel = this.orderList.cancel.length
        this.countOrderCreditTerm = this.orderList.credit_term.length
        // console.log(this.countOrderAll, this.countOrderPending, this.countOrderNotpaid, this.countOrderFail, this.countOrderSuccess, this.countOrderCancel)
        if (this.StateStatus === 'ทั้งหมด') {
          this.DataTable = this.orderList.all
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        } else if (this.StateStatus === 'ยังไม่ชำระเงิน') {
          this.DataTable = this.orderList.not_paid
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        } else if (this.StateStatus === 'ชำระเงินสำเร็จ') {
          this.DataTable = this.orderList.success
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        } else if (this.StateStatus === 'ชำระเงินไม่สำเร็จ') {
          this.DataTable = this.orderList.fail
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        } else if (this.StateStatus === 'ชำระเงินแบบเครดิตเทอม') {
          this.DataTable = this.orderList.credit_term
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        } else if (this.StateStatus === 'ยกเลิก') {
          this.DataTable = this.orderList.cancel
          if (this.DataTable.length === 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
        }
        // console.log('DataTable===>', this.DataTable)
      } else if (res.message === 'An error has occurred. Please try again in an hour or two.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({
          toast: true,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          icon: 'error',
          title: 'SERVER ERROR'
        })
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({
          toast: true,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          icon: 'error',
          text: 'ผู้ใช้งานนี้ถูกใช้งานอยู่'
        })
        localStorage.removeItem('oneData')
      }
    },
    countOrdar (pagination) {
      this.showCountOrder = pagination.itemsLength
    },
    async UpdateStatusBuyer (item) {
      // console.log(item)
      if (item.seller_sent_status === 'not_sent') {
        this.$swal.fire({
          icon: 'warning',
          text: 'สินค้ากำลังจัดส่ง',
          showConfirmButton: false,
          timer: 1500
        })
        await this.ListDataTable()
      } else {
        const update = {
          order_number: item.order_number,
          buyer_received_status: item.buyer_received_status
        }
        // console.log('update', update)
        await this.$store.dispatch('actionUpdateStatusBuyer', update)
        this.$swal.fire({
          icon: 'success',
          text: 'บันทึกข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 1500
        })
        await this.ListDataTable()
      }
    },
    async GoToPayment (item) {
      const PaymentID = {
        payment_transaction_number: item.payment_transaction_number
      }
      // console.log('payment_transaction_number', PaymentID)
      await this.$store.dispatch('ActionGetPaymentPage', PaymentID)
      var response = this.$store.state.ModuleCart.stateGetPaymentPage
      // console.log('respose paymenttttttttt', response)
      await localStorage.setItem('PaymentData', Encode.encode(response))
      this.$router.push('/RedirectPaymentPage')
    },
    async orderDetail (val) {
      // console.log('path to not tell =====>', val.pdf_for_buyer)
      window.open(`${val.pdf_for_buyer}`)
      // var data = {
      //   payment_transaction_number: val.payment_transaction_number
      // }
      //   console.log('data naja', data)
      // await this.$store.dispatch('actionOrderDetail', data)
      // await this.$router.push({ path: '/quotation1shop' }).catch(() => {})
      // var response = await this.$store.state.ModuleOrder.stateOrderDetailData
      // console.log('order detail na', response)
      // if (response.result === 'SUCCESS') {
      //   this.OrderDetailProp = response.data
      //   console.log('กี่ร้านนะะะะะะะะะ', response.data[0].order_number[0])
      // }
    },
    SelectDetailOrder (item) {
      // console.log('SelectDetailOrder', item)
      this.StateStatus = item
      this.page = 1
    },
    SwitchRole () {
      this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
      this.ListDataTable()
    },
    // async getDataTable () {
    //   this.overlay = true
    //   const data = {
    //     procurement_org_id: this.ProcurementData.procurement_org_id
    //   }
    //   await this.$store.dispatch('actionListOrderProcurement', data)
    //   var response = await this.$store.state.ModuleCart.stateListOrderProcurement
    //   // console.log('response List Order Procurement', response)
    //   if (response.result === 'SUCCESS') {
    //     this.responseData = response.data
    //     this.overlay = false
    //   }
    // },
    async pendingData (item) {
      this.overlay = true
      const data = {
        order_id: item.order_id
      }
      await this.$store.dispatch('actionOrderDetail', data)
      var response = await this.$store.state.ModuleCart.stateOrderDetailData
      // console.log('response detail order', response)
      if (response.result === 'SUCCESS') {
        this.overlay = false
        localStorage.setItem('MyOrderDetail', Encode.encode(JSON.stringify(response.data)))
        this.$router.push('/myorderdetail')
      }
    },
    goDetailPO (item) {
      var orderNumber = item.payment_transaction_number
      if (this.MobileSize === false) {
        this.$router.push({ path: `/orderDetailCompany?orderNumber=${orderNumber}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/orderDetailCompanyMobile?orderNumber=${orderNumber}` }).catch(() => {})
      }
      // if (item.transaction_status === 'Pending' || item.transaction_status === 'Approve') {
      //   if (this.MobileSize === false) {
      //     this.$router.push({ path: '/pobuyerdetailapprove' }).catch(() => {})
      //   } else {
      //     this.$router.push({ path: '/pobuyerdetailapproveMobile' }).catch(() => {})
      //   }
      // } else {
      //   var orderNumber = item.payment_transaction_number
      //   if (this.MobileSize === false) {
      //     this.$router.push({ path: `/orderDetailCompany?orderNumber=${orderNumber}` }).catch(() => {})
      //   } else {
      //     this.$router.push({ path: `/orderDetailCompany?orderNumber=${orderNumber}` }).catch(() => {})
      //   }
      // }
    }
  }
}
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 14px !important;
}
</style>

<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(8) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(1) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(8) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
        }
      }
    }
  }
</style>

<style scoped>
.fontSizeDetail {
  font-weight: 700 !important; font-size: 14px !important; line-height: 22px !important; color: #333333 !important;
}
.v-data-table /deep/ .v-data-footer {
  font-size: 0.62rem;
}
</style>
